// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-message {
  margin-top: 8px;
  margin-bottom: 8px;
}

.form-field-space {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.change-password {
  margin-top: 10px;
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/myaccount/myaccount.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,0BAAA;EACA,6BAAA;AACF;;AAIA;EACE,gBAAA;EACA,mBAAA;AADF","sourcesContent":[".error-message {\r\n  margin-top: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.form-field-space {\r\n  margin-top: 5px !important;\r\n  margin-bottom: 5px !important;\r\n\r\n}\r\n\r\n\r\n.change-password{\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
